/**
 * Alert Service Types
 *
 * Type definitions for alert API operations.
 */

/**
 * Error thrown by alert API operations
 */
export class AlertApiError extends Error {
  constructor(
    message: string,
    public readonly statusCode: number,
    public readonly alertId?: number
  ) {
    super(message);
    this.name = 'AlertApiError';
  }
}

/**
 * Parameters for sending notifications
 */
export interface NotifyAlertParams {
  alertId: number;
  channelIds: number[];
}

/**
 * Result from notify operation
 */
export interface NotifyAlertResult {
  success: boolean;
  sent_to?: string[];
  skipped?: Array<{
    channel_id: number;
    reason: string;
  }>;
}
